/**
 * @class
 */
import Base from './attribute';

import {ids as attributeTypeIds} from '@netx/core-asset/properties/attributes';

export default class Attribute_Select extends Base {
	/** @type {object} */
	get defaults() {
		return {
			...super.defaults,
			type: attributeTypeIds.select,
		};
	}

	/** @type {string} */
	static get __name__() {
		return 'Attribute_Select';
	}
}
